
<script setup>
import { useConfig } from "@/composables/useConfig";
import { Field, Form } from "vee-validate";
import { computed, ref, watch } from "vue";
import * as Yup from "yup";
import { useBettorStore } from "../../src/stores/bettor.store";
import { useAuthStore } from "../stores/auth.store";
const authStore = useAuthStore();
const bettorStore = useBettorStore();
const { config } = useConfig();
const showUpdatePassword = computed(() => authStore.$state?.show_update_password);
const password = ref("");
const confirm_password = ref("");
const showUpdatePasswordModal = ref((false));
const schema = Yup.object().shape({
  password: Yup.string().required("New Password is required").matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?=.*\d).+$/,
    "Password must contain at least one lowercase letter, one uppercase letter, one digit and one symbol"
  ).min(8, "Password must be at least 8 to 64 characters long").max(64),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

async function onSubmit() {
  await bettorStore.updatePassword(password.value, confirm_password.value);
  setTimeout(() => {
    showUpdatePasswordModal.value = false;
  }, 1000);
}
const checkPasswordStatus = () => {
  if(showUpdatePassword.value && authStore.user.pass_status == 1) {
    showUpdatePasswordModal.value = true;
  } else {
    showUpdatePasswordModal.value = false;
  }
}
watch([showUpdatePassword], () => {
  checkPasswordStatus();
});


const passwordCross = () => {
  showUpdatePasswordModal.value = false;
}
</script>
<template>
     <div class="tokenInput" v-if="showUpdatePasswordModal">
      <Form
            @submit="onSubmit"
            :validation-schema="schema"
            v-slot="{ errors, isSubmitting }"
          >
      <div class="mb-3 py-3 px-5  bg-white rounded-3 updatePassword" >
        <a class="d-inline-flex justify-content-end w-100" @click="passwordCross">
          <i class="fa cursorPointer fa-times"></i>
        </a>
        <div class="my-2 d-flex justify-content-center align-items-center">
          <img
            style="max-width: 45px"
            src="/images/only-logo.png"
            class="img-fluid me-1"
            alt=""
          />
          <img
            :style="config?.updatePasswordProhiBetLogo.style || 'max-width: 115px'"
            :src="config?.updatePasswordProhiBetLogo.src || '/images/p-logo-new.png'"
            :class="config?.updatePasswordProhiBetLogo.class || 'img-fluid ms-1 me-3'"
            alt=""
          />
        </div>
        <div class="mb-3">
        <label for="newpass" class="form-label fw-bold"
          >New Password</label
        >
        
        <Field
                type="password"
                name="password"
                class="form-control"
                minlength="7"
                v-model="password"
                id="newpass"
                aria-describedby="emailHelp"
                :class="{ 'is-invalid': errors.password }"
              />
              <div class="invalid-feedback">{{ errors.password }}</div>
      </div>
      <div class="mb-3">
        <label for="confpass" class="form-label fw-bold"
          >Confirm Password</label
        >
        <Field
                type="password"
                name="confirm_password"
                class="form-control"
                v-model="confirm_password"
                id="confpass"
                aria-describedby="emailHelp"
                :class="{ 'is-invalid': errors.confirm_password }"
              />
              <div class="invalid-feedback">{{ errors.confirm_password }}</div>
      </div>
      <div class="text-center">
        <button id="updatePassword" class="btn bgProhib" :disabled="isSubmitting">
                <span
                  v-show="isSubmitting"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                Update Password
              </button>
        </div>
       
      </div>
    </Form>
  </div>
</template>
<script>
export default {
  name: "UpdatePassword",
};
</script>